module.exports = __webpack_public_path__ + "static/img/ico_qrcode.3dcabf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business_cooperation/ico_qrcode.png
// module id = Khmn
// module chunks = 0